import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@api/api';
import moment from 'moment';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@/api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'ToxicChemicalDrawer',
  components: {
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '易制毒化学品管理表单',
      userTree: [],
      companyList: [],
      form_fields: ['prUserId', 'paUserId', 'approvalUserId', 'companyId', 'agreementType', 'deliverStatus'],
      validatorRules: {
        prUserId: {
          rules: [{
            required: true,
            message: '请选择专管员!'
          }]
        },
        paUserId: {
          rules: [{
            required: true,
            message: '请选择单位负责人!'
          }]
        },
        approvalUserId: {
          rules: [{
            required: true,
            message: '请选择单位法人!'
          }]
        },
        companyId: {
          rules: [{
            required: true,
            message: '请选择与供应商!'
          }]
        },
        agreementType: {
          rules: [{
            required: true,
            message: '请选择合同类型!'
          }]
        }
      },
      url: {}
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loadTreeList();
    this.loadCompany();
  },
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id == null) {
        this.model.deliverStatus = '2';
      }

      this.compareStatus = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction('/ea/company/info/queryCompanyName').then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};